import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Spinner from "../layout/Spinner";

const AllReports = ({ auth: { allUser, isAuthenticated, user, users } }) => {
  let loggedUserInstitutionData = JSON.parse(
    localStorage.getItem("loggedUserInstitutionData")
  );
  const allAccess = [];
  loggedUserInstitutionData &&
    loggedUserInstitutionData.access &&
    loggedUserInstitutionData.access.map((access) =>
      allAccess.push(access.accessName)
    );

  const allPermission = [];
  loggedUserInstitutionData &&
    loggedUserInstitutionData.permission &&
    loggedUserInstitutionData.permission.map((permission) =>
      allPermission.push(permission.permissionName)
    );

  return !isAuthenticated || !user || !users ? (
    <Spinner />
  ) : (
    <Fragment>
      <div className="container container_align ">
        <div className="col-lg-11 col-md-11 col-sm-12 col-12">
          <h2 className="heading_color">All Reports </h2>
          <hr />
        </div>

        <section className="all_report">
          {/* {allPermission && allPermission.includes("SingleSkill") && (
            <div className="card reportCard card-content ">
              <cetner>
              
                <Link to="/skill-training-report">
                  <img
                    className="ReportImg log"
                    src={require("../../static/images/skill.png")}
                    alt="Skill Report"
                    title="Skill Report"
                  />
                  <h4>Skill Report </h4>
                </Link>
              </cetner>
            </div>
          )} */}

          {/* <div className="card reportCard card-content log "> */}

            {/* Batchwise Report */}
            {/* <div>
              <cetner>
                <Link
                  to="/batchwise-report"
                  onClick={localStorage.removeItem("selBatchwiseReport")}
                >
                  <img
                    className="ReportImg log "
                    src={require("../../static/images/batches.png")}
                    alt="Batchwise Report"
                    title="Batchwise Report"
                  />
                  <h5>Batchwise Report</h5>
                </Link>
              </cetner>
            </div>

          </div> */}
           <div className="card reportCard card-content log ">
            <div>
              <center>
                {/* Income and Expenditure Report */}
                <Link to="/batchwise-report"
                  onClick={localStorage.removeItem("selBatchwiseReport")}>
                  <img
                    className="ReportImg log"
                    src={require("../../static/images/batches.png")}
                    alt="Batchwise Report"
                    title="Batchwise Report"
                     style={{ width: "220px", height: "190px" }}
                  />
                  <p className="cardcontentStyle">Batchwise Report</p>
                </Link>
              </center>
            </div>
          </div>
{user && user.institutionId != "63c0e52501d22dcc13f12c32" &&(
          <div className="card reportCard card-content log ">
            <div>
              <center>
                {/* Income and Expenditure Report */}
                <Link to="/income-expense-report">
                  <img
                    className="ReportImg log"
                    src={require("../../static/images/incomeexpense1.png")}
                    alt="incomeexpense Report"
                    title="incomeexpense Report"
                    style={{ width: "195px", height: "190px" }}
                  />
                  <p className="cardcontentStyle">Income and Expense Report</p>
                </Link>
              </center>
            </div>
          </div>
)}

          <div className="card reportCard card-content log">
            <div>
              <center>
                {/* Monthwise I & E Report */}
                <Link to="/monthly-income-expense-report">
                  <img
                    className="ReportImg log"
                    src={require("../../static/images/incomeexpense.png")}
                    alt="Monthwise Income&Expense Report"
                    title="Monthwise Income&Expense Report"
                    style={{ width: "170px", height: "190px" }}
                  />
                  <p className="cardcontentStyle">Monthwise I & E Report</p>
                </Link>
              </center>
            </div>
          </div>
{user && user.institutionId != "63c0e52501d22dcc13f12c32" &&(
          <div className="card reportCard card-content log">
            <div>
              <center>
                {/* Profit and Loss Report */}
                <Link to="/profit-loss-report">
                  <img
                    className="ReportImg log"
                    src={require("../../static/images/profitloss.png")}
                    alt="Profit and Loss Report"
                    title="Profit and Loss Report"
                  />
                  <p className="cardcontentStyle">Profit and Loss Report </p>
                </Link>
              </center>
            </div>
          </div>
)}

          {allPermission && allPermission.includes("Incharge_Module") && (
            <div className="card reportCard card-content log">
              <div>
                <center>
                  {/* Incharge wise report */}
                  <Link to="/inchargewise-report">
                    <img
                      className="ReportImg log"
                      src={require("../../static/images/incharge.png")}
                      alt="Inchargewise Report"
                      title="Inchargewise Report"
                    />
                    <p className="cardcontentStyle">Inchargewise Report</p>
                  </Link>
                </center>
              </div>
            </div>
          )}

          {allPermission && allPermission.includes("Occupation") && (
            <div className="card reportCard card-content log ">
              <div>
                <center>
                  <Link to="/occupation-reports">
                    <img
                      className="ReportImg log mt-1"
                      src={require("../../static/images/occupation.png")}
                      alt="Occupation Report"
                      title="Occupation Report"
                      style={{ width: "190px", height: "175px" }}
                    />
                    <p className="cardcontentStyle mt-2" >Occupation Report</p>
                  </Link>
                </center>
              </div>
            </div>


          )}

          {user && user.institutionId != "63009e55d95ce47f30877a6a" &&
            (allPermission && allPermission.includes("Category")) && (
              // Categorywise Report

              <div className="card reportCard card-content log">
                <div>
                  <center>
                    <Link to="/Shg-Categorywise-Report">
                      <img
                        className="ReportImg log"
                        src={require("../../static/images/ShgCategories.png")}
                        alt="Categorywise Report"
                        title="Categorywise Report"
                      />
                      <p className="cardcontentStyle">Categorywise Report</p>
                    </Link>
                  </center>
                </div>
              </div>
            )}

          {allPermission && allPermission.includes("Donor_Report") && (
            // Donor Report
            <div className="card reportCard card-content log">
              <div>
                <center>
                  <Link to="/Shg-Donor-Report ">
                    <img
                      className="ReportImg log mt-2"
                      src={require("../../static/images/DonorReport2.png")}
                      alt="Donor Report"
                      title="Donor Report"
                      style={{ width: "190px", height: "175px" }}
                    />
                    <p className="cardcontentStyle mt-1" >Donor Report</p>
                  </Link>
                </center>
              </div>
            </div>
          )}

          {allPermission && allPermission.includes("skill") && (
            // Skill Report 
            <div className="card reportCard card-content log">
              <div>
                <center>
                  <Link to="/skill-training-report">
                    <img
                      className="ReportImg log "
                      src={require("../../static/images/skill.png")}
                      alt="Skill Report"
                      title="Skill Report"
                      style={{ width: "190px", height: "175px" }}
                    />
                    <p className="cardcontentStyle mt-2">Skill Report </p>
                  </Link>
                </center>
              </div>
            </div>


          )}

          {allPermission && allPermission.includes("Memberwise-Loan-Report") && (
            // Memberwise Loan Report
            <div className="card reportCard card-content log">
              <div>
                <center>
                  <Link to="/Memberwise-loan-report">
                    <img
                      className="ReportImg log "
                      src={require("../../static/images/memrep.png")}
                      alt="Memberwise loan report"
                      title="Memberwise loan report"
                      style={{ width: "190px", height: "175px" }}
                    />
                    <p className="cardcontentStyle mt-2">Memberwise Loan Report</p>
                  </Link>
                </center>
              </div>
            </div>
          )}

          {allPermission && allPermission.includes("AssaReports") && (
            <>
              {/* Income & Expenses Report (Customized)  */}
              <div className="card reportCard card-content log">
                <div>
                  <Link to="/AssaIncomeExpenseReport">
                    <center>
                      <img
                        className="ReportImg log "
                        src={require("../../static/images/ie.png")}
                        alt="Income & Expenses Report "
                        title="Income & Expenses Report "
                        style={{ width: "190px", height: "175px" }}
                      />
                      <p className="mt-2 cardcontentStyle">Income & Expense Report (Custom) </p>
                    </center>
                  </Link>
                </div>
              </div>

              {/* Loan Status Report (Customized) */}
              <div className="card reportCard card-content log">
                {/* <div> */}
                  <center>
                    <Link to="/SeeAllMemLoan">
                      <img
                        className="ReportImg log "
                        src={require("../../static/images/wayoff.png")}
                        alt="Income & Expenses Report "
                        title="Income & Expenses Report "
                        // style={{ height: "160px", width: "160px" }}
                        style={{ width: "190px", height: "175px" }}
                      />
                      <p className="cardcontentStyle mt-2">Loan Status Report (Custom)</p>
                    </Link>
                  </center>
                {/* </div> */}
              </div>

              {/* Assets & Liabilities Report (Customized)  */}
              <div className="card reportCard card-content log">
                <div>
                  <center>
                    <Link to="/AssetsandLiabilities" >
                      <img
                        className="ReportImg log  "
                        src={require("../../static/images/al.jpg")}
                        alt="Assets and Liability Report"
                        title="Assets and Liability Report"
                        style={{ width: "190px", height: "175px" }}
                      />
                      <p className="cardcontentStyle mt-2">Balance Sheet (Custom) </p>
                    </Link>
                  </center>
                </div>
              </div>
            </>
          )}

          {allPermission && allPermission.includes("Attendance") && (

            // Attendence Report
            <div className="card reportCard card-content log">
              <div>
                <center>
                  <Link to="/attendence-report">
                    <img
                      className="ReportImg log mt-2"
                      src={require("../../static/images/attendence.png")}
                      alt="Attendence Report"
                      title="Attendence Report"
                      // style={{ height: "190px", width: "190px" }}
                      style={{ width: "190px", height: "175px" }}
                    />
                    <p className="cardcontentStyle " >Attendence Report</p>
                  </Link>
                </center>
              </div>
            </div>
          )}


          {allPermission && allPermission.includes("AssaReports") && (


            <div className="card reportCard card-content log">
              <div>
                <center>
                  <Link to="/TallyReport" onClick={() => localStorage.removeItem("batchData")}>
                    <img
                      className="ReportImg log mt-3 "
                      src={require("../../static/images/TallyReport.png")}
                      alt="Tally Report"
                      title="Tally Summary Report"
                      style={{ width: "150px", height: "160px" }}
                    />
                    <p className="cardcontentStyle mt-2">Tally Summary Report</p>
                  </Link>
                </center>
              </div>
            </div>


          )}
    {loggedUserInstitutionData._id == "626a0c943fd98086d0ebc766" && (
      <>
           <div className="card reportCard card-content log">
              <div>
                <center> 
                  <Link to="ProductReport">
                    <img
                      className="ReportImg log mt-3 "
                      src={require("../../static/images/product_Report.png")}
                      alt="Product Report"
                      title="Product  Report"
                      style={{ width: "150px", height: "160px"}}
                    />
                    <p className="cardcontentStyle mt-2">Product Report</p>
                  </Link>
                </center>
              </div>
            </div>

            <div className="card reportCard card-content log">
              <div>
                <center> 
                  <Link to="ModifiedProductReport">
                    <img
                      className="ReportImg log mt-3 "
                      src={require("../../static/images/product_Report.png")}
                      alt="ModifiedProduct Report"
                      title="ModifiedProduct  Report"
                      style={{ width: "150px", height: "160px"}}
                    />
                    <p className="cardcontentStyle mt-2">Modified Product Report</p>
                  </Link>
                </center>
              </div>
            </div>
            </>
            )}

 </section>
      </div>
    </Fragment>
  );
};

AllReports.propTypes = {
  auth: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(AllReports);
{
  /* <div className="row col-lg-11 col-md-11 col-sm-12 col-12 py-5  ">
            {allPermission && allPermission.includes("Memberwise-Loan-Report") && (
              <div
                className={
                  allAccess && allAccess.includes("skill")
                    ? "col-lg-3 col-md-6 col-sm-12 col-12 mt-5"
                    : "col-lg-3 col-md-6 col-sm-12 col-12"
                }
              > */
}
{
  /* <div className="card card-content ">
                  <center>
                    <Link to="/edit-meeting">
                      <img
                        className="ReportImg log"
                        src={require("../../static/images/edit_meeting1.jpg")}
                        alt="Edit Meeting"
                        title="Edit Meeting"
                      />
                      <h4 className="pt-4">Edit Meeting</h4>
                    </Link>
                  </center>
                </div> */
}
{
  /* ):(<></>) */
}
{
  /* </div>
            )}
          </div> */
}
{
  /* <div className="row col-lg-11 col-md-11 col-sm-12 col-12 py-5"> */
}

{
  /* </div> */
}

{
  /* <div className="col-lg-2 col-md-6 col-sm-12 col-12 ">
                 <div className="card card-content ">
                   <center>
                     <Link to="/skill-training-report">
                     <img
                       className="ReportImg log"
                        src={require("../../static/images/report.png")}
                       alt="Skill Report"
                       title="Skill Report"
                     />
                     <h4>Member Wise Loan Report</h4>
                     </Link>
                   </center>
                 </div>
               </div> */
}
